import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faCheckSquare from '@fortawesome/fontawesome-free-solid/faCheckSquare';
import inspectionServiceImage from '../../images/inspection-service.jpg';
import operationSeviceImage from '../../images/operation-service.jpg';
import repairServiceImage from '../../images/repair-service.jpg';
import jettingServiceImage from '../../images/sewer-jetting-service.jpg';
import cameraServiceImage from '../../images/sewer-camera-service.jpg';
//import valveServiceImage from '../../images/valve-repair-service.jpg';

const ServicesPage = () => {
  return (
    <div>
      <Container fluid={true}>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">Services</h1>
          </Col>
        </Row>

        <Row>
          <Col md={1} />
          <Col md={10}>
            <p className="text-center">
              RK Water provides a full range of services for all sizes of water
              and wastewater systems.
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="my-4">
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row className="featurette services">
          <Col md={7}>
            <h2 className="featurette-heading">System Operation</h2>
            <p className="lead">
              RK Water offers our extensive experience & management background
              in working with water systems & water boards.
            </p>
            <p>
              Our certified operators provide system operation, maintenance,
              site checks, leak checks, meter reading and more.
            </p>
            <h3>Water/Wastewater Systems</h3>
            <p>
              Periodic checks of treatment plants, wells, booster pumps,
              chemical feed pumps, master meters, etc.
            </p>
            <h4>Compliance</h4>
            <p>
              Let us keep your system in compliance. We can manage sampling,
              testing, reporting, and all other documentation as required by
              State and Federal Regulations. We can also provide assistance with
              getting back into compliance after failed inspections.
            </p>
          </Col>
          <Col md={5}>
            <img
              className="featurette-image img-fluid ml-auto rounded service-img"
              src={operationSeviceImage}
              alt="Water and Wastewater System Operation"
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row className="featurette services">
          <Col md="7 order-md-2">
            <h2 className="featurette-heading">Repair Services</h2>
            <p className="lead">
              We offer a variety of repair services for water and wastewater
              systems. We can repair:
            </p>
            <ul className="fa-ul">
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Water system leaks
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Valves
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Pressure reducing valves 2"-12"
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Fire Hydrants
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Wastewater gravity main leaks
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Wastewater treatment plants
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Pumps
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Motors
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Lift Stations
              </li>
            </ul>
          </Col>
          <Col md="5 order-md-1">
            <img
              className="featurette-image img-fluid ml-auto rounded service-img"
              src={repairServiceImage}
              alt="Water and Wastewater System Operation"
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row className="featurette services">
          <Col md={7}>
            <h2 className="featurette-heading">Sewer Jetting</h2>
            <p className="lead">
              High-pressure sewer jetting is an efficient, economical, and
              environmentally friendly method for cleaning gravity sewer mains.
            </p>
            <p>
              During the process, water is sprayed through the line at high
              pressure, removing buildup from grease and debris.{' '}
            </p>
            <p>
              Regular sewer jet maintenance keeps lines flowing and can save on
              repair costs. We can clean your system and get your lines flowing
              properly.
            </p>
          </Col>
          <Col md={5}>
            <img
              className="featurette-image img-fluid ml-auto rounded service-img"
              src={jettingServiceImage}
              alt="Water and Wastewater System Operation"
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row className="featurette services">
          <Col md="7 order-md-2">
            <h2 className="featurette-heading">Sewer Camera</h2>
            <p className="lead">
              Sewer cameras provides a reliable, non-invasive way to visually
              inspect lines for issues.
            </p>
            <p>
              Camera inspections can identify problems in your system before
              digging. Video inspection in pipelines can help identify:
            </p>
            <ul className="fa-ul">
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Main breaks
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Location of service taps
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Root intrusion
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Debris blockages
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Leaking pipes and joints
              </li>
              <li>
                <FontAwesomeIcon icon={faCheckSquare} className="mr-2" />
                Deteriorated materials
              </li>
            </ul>
          </Col>
          <Col md="5 order-md-1">
            <img
              className="featurette-image img-fluid mx-auto rounded service-img"
              src={cameraServiceImage}
              alt="Sewer Camera Inspections"
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row className="featurette services">
          <Col md={7}>
            <h2 className="featurette-heading">Inspections</h2>
            <p className="lead">
              We offer new construction and repair inspection services for water
              and wastewater systems.
            </p>
          </Col>
          <Col md={5} className="mb-4">
            <img
              className="featurette-image img-fluid ml-auto rounded service-img"
              src={inspectionServiceImage}
              alt="Inspections"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ServicesPage;



// WEBPACK FOOTER //
// ./src/components/service/ServicesPage.js